import React, { FC } from 'react';
import { Box, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rem } from 'utils/fonts';
import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { useSelector } from 'react-redux';
import { mq } from 'styles/breakpoints';

interface LegendItems {
  name: string;
  color?: string;
}

interface LegendProps {
  items: LegendItems[];
}

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 20px 0 0 0;
  margin: 0;
  ${mq.md} {
    justify-content: flex-start;
  }
`;

const Item = styled(Box)`
  display: inline-block;
  padding: 0 22px 0 13px;
  font-size: ${rem(12)};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    border-radius: 50%;
    left: 0;
    top: 6px;
    width: 5px;
    height: 5px;
  }

  &:last-of-type {
    padding-right: 0;
  }
`;

const Legend: FC<LegendProps> = ({ items }) => {
  const { colors } = useTheme();
  const isCorporateTheme = useSelector(isCorporateThemeSelector);
  return (
    <List>
      {items.map(entry => (
        <Item
          as="li"
          key={`item-${entry.name}`}
          color={isCorporateTheme ? colors.secondary[400] : colors.secondary[500]}
          fontWeight={isCorporateTheme ? '500' : '400'}
          _before={{ bg: entry.color ?? 'black' }}
        >
          {entry.name}
        </Item>
      ))}
    </List>
  );
};

export default Legend;
